module.exports = __webpack_public_path__ + "static/media/file-upload.7e8aed14.svg";